// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media screen and (max-width: 700px) {
.process-model[data-v-2bf0ddcd] {
    visibility: hidden;
    display: none;
}
}
.process-model[data-v-2bf0ddcd] {
  list-style: none;
  padding: 0;
  position: relative;
  max-width: 600px;
  margin: 0 auto;
  border: none;
  z-index: 0;
  direction: ltr;
}
.process-model li[data-v-2bf0ddcd]::after {
  background: #e5e5e5 none repeat scroll 0 0;
  bottom: 0;
  content: "";
  display: block;
  height: 4px;
  margin: 0 auto;
  position: relative;
  right: -50px;
  top: -80px;
  width: 85%;
  z-index: -1;
}
.process-model li.visited[data-v-2bf0ddcd]::after {
  background: #57b87b;
}
.process-model li[data-v-2bf0ddcd]:last-child::after {
  width: 0;
}
.process-model li[data-v-2bf0ddcd] {
  display: inline-block;
  width: 18%;
  text-align: center;
  float: none;
}
.process-model li a[data-v-2bf0ddcd] {
  padding: 0;
  border: none;
  color: #606060;
  cursor: default;
}
.process-model li.active[data-v-2bf0ddcd],
.process-model li.visited[data-v-2bf0ddcd] {
  color: #57b87b;
}
.process-model li.active a[data-v-2bf0ddcd],
.process-model li.active a[data-v-2bf0ddcd]:hover,
.process-model li.active a[data-v-2bf0ddcd]:focus {
  color: #606060;
  cursor: pointer;
}
.process-model li.visited a[data-v-2bf0ddcd],
.process-model li.visited a[data-v-2bf0ddcd]:hover,
.process-model li.visited a[data-v-2bf0ddcd]:focus {
  cursor: pointer;
  color: #57b87b;
}
.process-model li p[data-v-2bf0ddcd] {
  font-size: 14px;
  margin-top: 11px;
}
.process-model li.active p[data-v-2bf0ddcd] {
  font-weight: 600;
}
.process-model li.active p[data-v-2bf0ddcd],
.process-model li.visited p[data-v-2bf0ddcd] {
  max-width: 100px;
}
.process-model li i[data-v-2bf0ddcd] {
  display: block;
  height: 68px;
  width: 68px;
  text-align: center;
  margin: 0 auto;
  background: #f5f6f7;
  border: 2px solid #e5e5e5;
  line-height: 65px;
  font-size: 30px;
  border-radius: 50%;
}
.active-wrap[data-v-2bf0ddcd] {
  background: #1E5DB7;
  background: -webkit-linear-gradient(#1E5DB7, #64A1E1);
  background: -o-linear-gradient(#1E5DB7, #64A1E1);
  background: -moz-linear-gradient(#1E5DB7, #64A1E1);
  background: linear-gradient(#1E5DB7, #64A1E1);
  padding: 5px;
  border-radius: 50%;
  display: inline-block;
}
.visited-wrap[data-v-2bf0ddcd] {
  background: #57b87b;
  background: -webkit-linear-gradient(#57b87b, #a1c1ac);
  background: -o-linear-gradient(#57b87b, #a1c1ac);
  background: -moz-linear-gradient(#57b87b, #a1c1ac);
  background: linear-gradient(#57b87b, #a1c1ac);
  padding: 5px;
  border-radius: 50%;
  display: inline-block;
}
.process-model li.active i .process-model li.visited i[data-v-2bf0ddcd] {
  background: #fff;
  border-color: #57b87b;
}

`, "",{"version":3,"sources":["webpack://./resources/assets/js/components/Ui/ProcessModel.vue"],"names":[],"mappings":";AA6FA;AACA;IACA,kBAAA;IACA,aAAA;AACA;AACA;AAEA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;AACA;AAEA;EACA,0CAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;AACA;AAEA;EACA,mBAAA;AACA;AAEA;EACA,QAAA;AACA;AAEA;EACA,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AACA;AAEA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AACA;AAEA;;EAEA,cAAA;AACA;AAEA;;;EAGA,cAAA;EACA,eAAA;AACA;AAEA;;;EAGA,eAAA;EACA,cAAA;AACA;AAEA;EACA,eAAA;EACA,gBAAA;AACA;AAEA;EACA,gBAAA;AACA;AAEA;;EAEA,gBAAA;AACA;AAEA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AACA;AAEA;EACA,mBAAA;EACA,qDAAA;EACA,gDAAA;EACA,kDAAA;EACA,6CAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AACA;AAEA;EACA,mBAAA;EACA,qDAAA;EACA,gDAAA;EACA,kDAAA;EACA,6CAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AACA;AAEA;EACA,gBAAA;EACA,qBAAA;AACA","sourcesContent":["<!--\nmodels [\n  {\n    icon: 'fa fa-users',\n    title: 'Admin Information',\n    percentage: '',\n  }\n]\n-->\n\n<template>\n  <ul class=\"process-model\">\n    <li\n      v-for=\"(model, key) in models\"\n      :class=\"getIconClass(key)\">\n      <a @click=\"changeStage(key)\">\n        <div :class=\"{\n          'active-wrap': stage === key,\n          'visited-wrap' : stage !== key && key < maxStage }\">\n          <i\n          :class=\"model.icon\"\n          aria-hidden=\"true\"/>\n        </div>\n        <p\n          class=\"no-margin\"\n          v-html=\"model.title\"/>\n      </a>\n    </li>\n  </ul>\n</template>\n\n<script>\nexport default {\n  props: {\n    models: {\n      type: Array,\n      default: () => [],\n      required: true,\n    },\n    maxStage: {\n      type: Number,\n      default: 0,\n      required: true,\n    },\n    currentStage: {\n      type: Number,\n      default: -1,\n      required: false,\n    },\n    disableMaxStageUpdate: {\n      type: Boolean,\n      default: false,\n      required: false,\n    }\n  },\n\n  data() {\n    return {\n      stage: 0,\n    };\n  },\n\n  watch: {\n    maxStage(val) {\n      if (!this.disableMaxStageUpdate) {\n        this.stage = val;\n        this.$emit('current-stage', this.stage);\n      }\n    },\n\n    currentStage(val) {\n      if (val >= 0) {\n        this.stage = val;\n      }\n    },\n  },\n\n  methods: {\n    getIconClass(stage) {\n      return `${stage === this.stage ? 'active' : ''} ${this.maxStage > stage ? 'visited' : ''}`;\n    },\n\n    changeStage(stage) {\n      if (stage <= this.maxStage) {\n        this.stage = stage;\n        this.$emit('current-stage', this.stage);\n      }\n    },\n  },\n};\n</script>\n<style scoped>\n\n@media screen and (max-width: 700px) {\n  .process-model {\n    visibility: hidden;\n    display: none;\n  }\n}\n\n.process-model {\n  list-style: none;\n  padding: 0;\n  position: relative;\n  max-width: 600px;\n  margin: 0 auto;\n  border: none;\n  z-index: 0;\n  direction: ltr;\n}\n\n.process-model li::after {\n  background: #e5e5e5 none repeat scroll 0 0;\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 4px;\n  margin: 0 auto;\n  position: relative;\n  right: -50px;\n  top: -80px;\n  width: 85%;\n  z-index: -1;\n}\n\n.process-model li.visited::after {\n  background: #57b87b;\n}\n\n.process-model li:last-child::after {\n  width: 0;\n}\n\n.process-model li {\n  display: inline-block;\n  width: 18%;\n  text-align: center;\n  float: none;\n}\n\n.process-model li a {\n  padding: 0;\n  border: none;\n  color: #606060;\n  cursor: default;\n}\n\n.process-model li.active,\n.process-model li.visited {\n  color: #57b87b;\n}\n\n.process-model li.active a,\n.process-model li.active a:hover,\n.process-model li.active a:focus {\n  color: #606060;\n  cursor: pointer;\n}\n\n.process-model li.visited a,\n.process-model li.visited a:hover,\n.process-model li.visited a:focus {\n  cursor: pointer;\n  color: #57b87b;\n}\n\n.process-model li p {\n  font-size: 14px;\n  margin-top: 11px;\n}\n\n.process-model li.active p {\n  font-weight: 600;\n}\n\n.process-model li.active p,\n.process-model li.visited p {\n  max-width: 100px;\n}\n\n.process-model li i {\n  display: block;\n  height: 68px;\n  width: 68px;\n  text-align: center;\n  margin: 0 auto;\n  background: #f5f6f7;\n  border: 2px solid #e5e5e5;\n  line-height: 65px;\n  font-size: 30px;\n  border-radius: 50%;\n}\n\n.active-wrap {\n  background: #1E5DB7;\n  background: -webkit-linear-gradient(#1E5DB7, #64A1E1);\n  background: -o-linear-gradient(#1E5DB7, #64A1E1);\n  background: -moz-linear-gradient(#1E5DB7, #64A1E1);\n  background: linear-gradient(#1E5DB7, #64A1E1);\n  padding: 5px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.visited-wrap {\n  background: #57b87b;\n  background: -webkit-linear-gradient(#57b87b, #a1c1ac);\n  background: -o-linear-gradient(#57b87b, #a1c1ac);\n  background: -moz-linear-gradient(#57b87b, #a1c1ac);\n  background: linear-gradient(#57b87b, #a1c1ac);\n  padding: 5px;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.process-model li.active i .process-model li.visited i {\n  background: #fff;\n  border-color: #57b87b;\n}\n\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
